import React from 'react'
import Header from './Header'
import Footer from './Footer'

const Table = () => {
    let courses=[
        {
            id:1,
            name:"UI & UX",
            duration:60,
            fee: 15000,
            img:"ui.webp",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        },
        {
            id:2,
            name:"JavaScript",
            duration:20,
            fee: 5000,
            img:"js.avif",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        },
        {
            id:3,
            name:"Angular",
            duration:60,
            fee: 20000,
            img:"angular.png",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        },
        {
            id:4,
            name:"React Js",
            duration:50,
            fee: 16000,
            img:"react.png",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        },
        {
            id:5,
            name:"Java",
            duration:90,
            fee: 25000,
            img:"java.webp",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Back-End"
        },
        {
            id:6,
            name:"Python",
            duration:80,
            fee: 22000,
            img:"python.jpg",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Back-End"
        },
        {
            id:7,
            name:"DotNet",
            duration:120,
            fee: 30000,
            img:"dotnet.png",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Back-End"
        },
        {
            id:8,
            name:"Node Js",
            duration:90,
            fee: 28000,
            img:"node js.webp",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Back-End"
        },
        {
            id:9,
            name:"Vue Js",
            duration:60,
            fee: 13000,
            img:"vuejs.png",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        }
    ]
  return (
    <>
      <Header />
      <div className="container my-5">
        <h1 className='text-center my-4 text-danger'>List Of Courses</h1>
        <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped table-dark">
                <thead>
                    <tr>
                        <th>Sno</th>
                        <th>Name</th>
                        <th>Image</th>
                        <th>Content</th>
                        <th>Duration</th>
                        <th>Fee</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Ui</td>
                        <td><img src="" alt="" /></td>
                        <td>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi, sunt nobis minima quam saepe eos nisi amet nulla fugit, quos ipsam inventore, unde ullam illum! Mollitia hic eum ipsum at.</td>
                        <td>60Days</td>
                        <td>15000</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Ui</td>
                        <td><img src="" alt="" /></td>
                        <td>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi, sunt nobis minima quam saepe eos nisi amet nulla fugit, quos ipsam inventore, unde ullam illum! Mollitia hic eum ipsum at.</td>
                        <td>60Days</td>
                        <td>15000</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Ui</td>
                        <td><img src="" alt="" /></td>
                        <td>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi, sunt nobis minima quam saepe eos nisi amet nulla fugit, quos ipsam inventore, unde ullam illum! Mollitia hic eum ipsum at.</td>
                        <td>60Days</td>
                        <td>15000</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Ui</td>
                        <td><img src="" alt="" /></td>
                        <td>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi, sunt nobis minima quam saepe eos nisi amet nulla fugit, quos ipsam inventore, unde ullam illum! Mollitia hic eum ipsum at.</td>
                        <td>60Days</td>
                        <td>15000</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Ui</td>
                        <td><img src="" alt="" /></td>
                        <td>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi, sunt nobis minima quam saepe eos nisi amet nulla fugit, quos ipsam inventore, unde ullam illum! Mollitia hic eum ipsum at.</td>
                        <td>60Days</td>
                        <td>15000</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Ui</td>
                        <td><img src="" alt="" /></td>
                        <td>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi, sunt nobis minima quam saepe eos nisi amet nulla fugit, quos ipsam inventore, unde ullam illum! Mollitia hic eum ipsum at.</td>
                        <td>60Days</td>
                        <td>15000</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Table
